/**
 * Object replacement character, used as a placeholder for objects.
 */
export const OBJECT_REPLACEMENT_CHARACTER = '\ufffc';

/**
 * Zero width non-breaking space, used as padding in the editable DOM tree when
 * it is empty otherwise.
 */
export const ZWNBSP = '\ufeff';
